import { useRouter } from 'next/navigation';

import { CollectionSubHeader, RibbonButton } from '@/components/atomic/atoms';
import { PAGE_NAME, captureGTMEventCTAClick } from '@/lib/gtm';

const CollectionHeader = ({
  buttonText,
  buttonUrl,
  ctaEventName,
  isOpenInSameTab,
  subTitle,
  title
}) => {
  const Router = useRouter();
  return (
    <div className='flex flex-row justify-between'>
      <CollectionSubHeader
        {...{
          title,
          subTitle,
          underline: true,
          subPosition: 'top',
          titleClass: 'flex flex-row uppercase tracking-widest'
        }}
      />
      <div className='flex flex-row self-end'>
        {buttonText && (
          <RibbonButton
            buttonText={buttonText}
            onClick={() => {
              ctaEventName &&
                captureGTMEventCTAClick({
                  ctaName: ctaEventName,
                  pageName: PAGE_NAME.HOME_PAGE.label
                });
              return isOpenInSameTab
                ? Router.push(buttonUrl)
                : window.open(buttonUrl, '_blank');
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CollectionHeader;
